module.exports = __webpack_public_path__ + "2020celebration/img/s3.ee01575b.png";